var _path, _path2, _path3, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    viewBox: "0 0 375 375",
    height: 375,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-37.5 -37.5H412.5V412.5H-37.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-37.5 -37.5H412.5V412.5H-37.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#062E64",
    d: "M-37.5 -37.5H412.5V412.5H-37.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 79.828125 3.582031 C 116.925781 3.582031 147.628906 -15.09375 147.628906 -53.730469 C 147.628906 -93.898438 113.34375 -102.34375 86.222656 -109.25 C 67.035156 -113.855469 51.683594 -117.691406 51.683594 -130.230469 C 51.683594 -142 64.21875 -147.371094 76.757812 -147.371094 C 91.339844 -147.371094 104.132812 -140.207031 104.132812 -124.601562 L 142.253906 -124.601562 C 142.253906 -160.421875 118.972656 -182.425781 77.78125 -182.425781 C 38.121094 -182.425781 12.792969 -162.980469 12.792969 -128.695312 C 12.792969 -90.0625 45.542969 -82.128906 72.664062 -75.476562 C 92.109375 -71.128906 108.484375 -67.289062 108.484375 -53.21875 C 108.484375 -39.914062 94.15625 -32.238281 79.570312 -32.238281 C 63.707031 -32.238281 49.378906 -40.679688 49.378906 -57.824219 L 10.234375 -57.824219 C 10.234375 -19.445312 38.632812 3.582031 79.828125 3.582031 Z M 79.828125 3.582031",
    transform: "translate(27.04 260.914)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#7DDCFA"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 128.695312 0 L 154.023438 0 L 111.042969 -72.664062 C 134.578125 -79.316406 150.699219 -99.015625 150.699219 -124.34375 C 150.699219 -156.070312 125.878906 -179.097656 92.363281 -179.097656 L 24.304688 -179.097656 L 24.304688 0 L 46.820312 0 L 46.820312 -69.847656 L 87.503906 -69.847656 Z M 46.820312 -157.605469 L 91.085938 -157.605469 C 113.089844 -157.605469 127.671875 -143.535156 127.671875 -124.34375 C 127.671875 -105.15625 113.089844 -91.339844 91.085938 -91.339844 L 46.820312 -91.339844 Z M 46.820312 -157.605469",
    transform: "translate(181.729 260.914)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSr);
export default __webpack_public_path__ + "static/media/SR.f4e17058e8d368501b1cf64011edf884.svg";
export { ForwardRef as ReactComponent };